var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer",
    width: 77.917,
    height: 77.917,
    viewBox: "0 0 77.917 77.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:#d6174a}\n        "))), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_78",
    d: "M39.958 8.083a31.875 31.875 0 1 0 31.875 31.875A31.875 31.875 0 0 0 39.958 8.083zM1 39.958a38.958 38.958 0 1 1 38.958 38.959A38.958 38.958 0 0 1 1 39.958z",
    "data-name": "Trazado 78",
    transform: "translate(-1 -1)",
    style: {
      fillRule: "evenodd",
      fill: "#d6174a"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_79",
    d: "M7.872 42.37a3.542 3.542 0 0 1 0-5.029L37.941 7.308a3.542 3.542 0 0 1 4.922 4.992L12.9 42.37a3.542 3.542 0 0 1-5.029 0z",
    className: "prefix__cls-2",
    "data-name": "Trazado 79",
    transform: "translate(13.803 13.269)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_80",
    d: "M7.449 7.449a3.542 3.542 0 0 1 4.994 0l30.069 30.033a3.556 3.556 0 1 1-5.029 5.029L7.449 12.443a3.542 3.542 0 0 1 0-4.994z",
    className: "prefix__cls-2",
    "data-name": "Trazado 80",
    transform: "translate(12.774 12.774)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0c03b6f98ce0267cb90ed644a67fb1a1.svg";
export { ForwardRef as ReactComponent };